export default __webpack_public_path__ + "static/media/deltara.5428319e.png";